<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.finca') }}:
                |
                | {{ restricao?.finca || restricao?.properties?.finca || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.padron') }}:
                |
                | {{ restricao?.padron || restricao?.properties?.padron || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.objectid') }}:
                |
                | {{ restricao?.objectid ? Number(restricao.objectid).toFixed(0) : restricao?.properties?.objectid ? Number(restricao.properties.objectid).toFixed(0) : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.id_parcela') }}:
                |
                | {{ restricao?.id_parcela ? Number(restricao.id_parcela).toFixed(0) : restricao?.properties?.id_parcela ? Number(restricao.properties.id_parcela).toFixed(0) : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dpto') }}:
                |
                | {{ restricao?.dpto || restricao?.properties?.dpto || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dist') }}:
                |
                | {{ restricao?.dist || restricao?.properties?.dist }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.zona') }}:
                |
                | {{ restricao?.zona || restricao?.properties?.zona }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.lote') }}:
                |
                | {{ restricao?.lote || restricao?.properties?.lote }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ccatastral') }}:
                |
                | {{ restricao?.ccatastral || restricao?.properties?.ccatastral || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.obs') }}:
                |
                | {{ restricao?.obs || restricao?.properties?.obs || '-' }}
                br
                Criticidade(
                    v-if='restricao.nivelAlerta',
                    :restricao='restricao'
                )
</template>

<script>
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
export default {
    name: 'fincas-paraguai',

    emits: ['highlightGeometry'],

    data() {
        return {};
    },

    components: {
        Criticidade
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        dataFormatada(data) {
            if (data && data.length > 0) {
                let ano = data.substring(0, 4);
                let mes = data.substring(5, 7);
                let dia = data.substring(8, 10);

                return dia + '/' + mes + '/' + ano;
            } else {
                return '-';
            }
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
